// import { ArrowRight, ChevronLeft, ChevronRight, X } from "lucide-react";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router";
// import { Checkbox } from "@mui/material";
// import { Button } from "@components/ui/button";
// import { useCountries } from "use-react-countries";
// import SimpleBar from "simplebar-react";
// import { useDispatch, useSelector } from "react-redux";
// import { Country, State, City } from "country-state-city";
// import { RootState } from "@redux/store";
// import {
//   updateContactLocation,
//   updateConuntryLocation,
// } from "@redux/slices/filter";
// import germany from "../../../../../assets/icons/germany.png";
// import switzerland from "../../../../../assets/icons/switzerland.png";
// import austria from "../../../../../assets/icons/austria.jfif";

// interface Props {
//   handleClose: () => void;
// }

// const ContactLocation: React.FC<Props> = ({ handleClose }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [countries, setCountries] = useState<any>([]);
//   const [states, setStates] = useState(false);
//   const [germanyStates, setGermanyStates] = useState(false);
//   const [switzerlandStates, setSwitzerlandStates] = useState(false);

//   useEffect(() => {
//     const countriesData = Country.getAllCountries();
//     const allowedCountries = ["DE", "AT", "CH"];
//     const filterCountries = (countries: any[]) => {
//       return countriesData.filter((country) =>
//         allowedCountries.includes(country.isoCode)
//       );
//     };
//     setCountries(filterCountries);
//     console.log(filterCountries);
//   }, []);

//   // State to store the search query
//   const [searchQuery, setSearchQuery] = useState("");

//   const selectedCountries = useSelector(
//     (state: RootState) => state.filter?.regionalFilters?.countryFilter
//   );

//   const handleCheckboxChange = (val: any) => {
//     const country = val.name;
//     const updatedCountries = {
//       ...selectedCountries,
//       [country]: !selectedCountries[country],
//     };
//     dispatch(updateConuntryLocation(updatedCountries));
//   };

//   console.log(selectedCountries);
//   // Function to filter countries based on search query
//   const filteredCountries = countries.filter((country: any) =>
//     country.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div
//       className=""
//       style={{
//         height: "100%",
//         overflow: "hidden",
//         position: "relative",
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           height: "100%",
//           width: "calc(100vw + 600px)",
//           opacity: 0.5,
//         }}
//       >
//         <iframe
//           className="border-card"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d310844.36298837874!2d13.095091822430753!3d52.506804156036814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a84e373f035901%3A0x42120465b5e3b70!2sBerlin%2C%20Germany!5e0!3m2!1sen!2s!4v1723725669690!5m2!1sen!2s"
//           width="100%"
//           height="100%"
//           allowFullScreen={true}
//           loading="lazy"
//         ></iframe>
//       </div>
//       <div className="flex flex-col justify-between h-full absolute top-0 w-full p-8">
//         <div>
//           <div className="flex justify-between items-center mb-5">
//             <h4 className="text-xl font-bold flex items-center -ms-2">
//               <ChevronLeft
//                 size={22}
//                 className="me-3 cursor-pointer"
//                 onClick={() => navigate(-1)}
//               />
//               Country Filter
//             </h4>
//             <X onClick={handleClose} className="cursor-pointer" />
//           </div>
//           <div className="flex gap-4">
//             <div className="bg-white rounded-lg w-1/3 px-6 py-4">
//               <h4 className="text-lg font-bold flex items-center mb-4">
//                 Countries
//               </h4>
//               {/* <div className="relative mb-2">
//                 <input
//                   className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-0 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
//                   id="searchCountry"
//                   type="text"
//                   placeholder="Search"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)} // Update search query state on input change
//                 />
//                 <div className="absolute right-0 inset-y-0 flex items-center">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="#71717A"
//                   >
//                     <path
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                       stroke-width="2"
//                       d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                     />
//                   </svg>
//                 </div>
//               </div> */}
//               <SimpleBar style={{ maxHeight: 320 }}>
//                 {/* {filteredCountries.map((val: any, index: number) => ( */}
//                 <div>
//                   <div
//                     // key={index}
//                     className={`flex items-end justify-between font-semibold cursor-pointer pt-3 border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1
//                       `}
//                   >
//                     <div
//                       className="flex items-center"
//                       onClick={() => setStates(!states)}
//                     >
//                       <ChevronRight size={22} />
//                       <div className="flex items-center">
//                         <img src={austria} alt="" className="h-4 w-6 mx-2" />
//                         <h6 className="ms-1">Austria</h6>
//                       </div>
//                     </div>
//                   </div>
//                   {states &&
//                     State.getStatesOfCountry("AT")?.map(
//                       (val: any, index: number) => (
//                         <div
//                           key={index}
//                           className={`flex items-end justify-between text-sm cursor-pointer text-[#71717A] pt-3 ${
//                             index < 8 &&
//                             "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
//                           }`}
//                           onClick={() => handleCheckboxChange(val)}
//                         >
//                           <h6 className="ms-1">{val.name}</h6>
//                           <Checkbox
//                             sx={{ padding: 0 }}
//                             checked={!!selectedCountries[val.name]}
//                           />
//                         </div>
//                       )
//                     )}
//                 </div>
//                 <div>
//                   <div
//                     className={`flex items-end justify-between font-semibold cursor-pointer pt-3 border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1
//                       `}
//                   >
//                     <div
//                       className="flex items-center"
//                       onClick={() => setGermanyStates(!germanyStates)}
//                     >
//                       <ChevronRight size={22} />
//                       <div className="flex items-center">
//                         <img src={germany} alt="" className="h-4 w-6 mx-2" />
//                         <h6 className="ms-1">Germany</h6>
//                       </div>
//                     </div>
//                   </div>
//                   {germanyStates &&
//                     State.getStatesOfCountry("DE")?.map(
//                       (val: any, index: number) => (
//                         <div
//                           key={index}
//                           className={`flex items-end justify-between text-sm cursor-pointer text-[#71717A] pt-3 ${
//                             index < 8 &&
//                             "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
//                           }`}
//                           onClick={() => handleCheckboxChange(val)}
//                         >
//                           <h6 className="ms-1">{val.name}</h6>
//                           <Checkbox
//                             sx={{ padding: 0 }}
//                             checked={!!selectedCountries[val.name]}
//                           />
//                         </div>
//                       )
//                     )}
//                 </div>
//                 <div>
//                   <div
//                     // key={index}
//                     className={`flex items-end justify-between font-semibold cursor-pointer pt-3
//                       `}
//                   >
//                     <div
//                       className="flex items-center"
//                       onClick={() => setSwitzerlandStates(!switzerlandStates)}
//                     >
//                       <ChevronRight size={22} />
//                       <div className="flex items-center">
//                         <img
//                           src={switzerland}
//                           alt=""
//                           className="h-4 w-6 mx-2"
//                         />
//                         <h6 className="ms-1">Switzerland</h6>
//                       </div>
//                     </div>
//                   </div>
//                   {switzerlandStates &&
//                     State.getStatesOfCountry("CH")?.map(
//                       (val: any, index: number) => (
//                         <div
//                           key={index}
//                           className={`flex items-end justify-between text-sm cursor-pointer text-[#71717A] pt-3 ${
//                             index < 8 &&
//                             "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
//                           }`}
//                           onClick={() => handleCheckboxChange(val)}
//                         >
//                           <h6 className="ms-1">{val.name}</h6>
//                           <Checkbox
//                             sx={{ padding: 0 }}
//                             checked={!!selectedCountries[val.name]}
//                           />
//                         </div>
//                       )
//                     )}
//                 </div>
//                 {/* ))} */}
//               </SimpleBar>
//             </div>
//           </div>
//         </div>
//         <div className="flex justify-end">
//           <Button onClick={() => navigate(-1)}>Save</Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactLocation;

import React, { useState, useMemo } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { ArrowRight, ChevronLeft, X } from "lucide-react";
import { useNavigate } from "react-router";
import { Checkbox } from "@mui/material";
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { updateContactLocation } from "@redux/slices/filter";
import { useCountries } from "use-react-countries";
import { FilterAtom } from "@/App";
import {useRecoilState } from "recoil";

interface Props {
  handleClose: () => void;
}

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const ContactLocation: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { countries } = useCountries();
  const selectedCountries = useSelector(
    (state: RootState) => state.filter?.contactFilters?.contactLocation
  );

  const [mapCenter, setMapCenter] = useState({
    lat: 52.5068,
    lng: 13.2846,
  });

  const handleCheckboxChange = (val: any) => {
    const country = val.name;
    const updatedCountries = {
      ...selectedCountries,
      [country]: !selectedCountries[country],
    };

    dispatch(updateContactLocation(updatedCountries));

    if (updatedCountries[country]) {
      setMapCenter({
        lat: val.coordinates[0],
        lng: val.coordinates[1],
      });
    }
  };

  const selectedCountry = useMemo(() => {
    return countries.find((country: any) => selectedCountries[country.name]);
  }, [selectedCountries, countries]);


  const [filter, setFilter] = useRecoilState(FilterAtom);
  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };


  return (
    <div
      style={{
        height: "100%",
        overflow: "hidden",
        position: "relative",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <LoadScript googleMapsApiKey="AIzaSyBi1-Mtd4gx1GfHuNwM6rXKIWRcBf5xNbo">
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={mapCenter}
          zoom={selectedCountry ? 6 : 4}
        >
          <Marker position={mapCenter} />
        </GoogleMap>
      </LoadScript>
      <div className="flex flex-col justify-between h-full absolute top-0 w-full p-8">
        <div>
          <div className="flex justify-between items-center mb-5">
            <h4 className="text-xl font-bold flex items-center -ms-2">
              <ChevronLeft
                size={22}
                className="me-3 cursor-pointer"
                onClick={() => navigate(-1)}
              />
              Contact Location
            </h4>
            <X onClick={handleClose} className="cursor-pointer" />
          </div>
          <div className="flex gap-4">
            <div className="bg-white rounded-lg w-1/3 px-6 py-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Countries
              </h4>
              <SimpleBar style={{ maxHeight: 310 }}>
                {countries.map((val: any, index: number) => (
                  <div
                    key={index}
                    className={`flex items-end justify-between text-sm font-medium cursor-pointer text-[#71717A] ${
                      index > 0 && "pt-3"
                    } ${
                      index < 8 &&
                      "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
                    }`}
                    onClick={() => handleCheckboxChange(val)}
                  >
                    <h6 className="ms-1">{val.name}</h6>
                    <Checkbox
                      sx={{ color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },padding: 0 }}
                      checked={!!selectedCountries[val.name]}
                      onClick={() => {
                        handleClick("Country Filter"); // Replace someValue with the actual value you want to pass
                        
                      }} 
                    />
                  </div>
                ))}
              </SimpleBar>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-end">
          <Button>
            Show Contacts
            <ArrowRight size={20} className="ms-2" />
          </Button>
        </div> */}
      </div>
    </div>
  );
};

export default ContactLocation;
